// extracted by mini-css-extract-plugin
module.exports = {"icon":"AlertIcon_icon__ERkO9","promo":"AlertIcon_promo__HzKmp"};